import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { PermissionScopeResponse } from '../../Interfaces/api/backoffice/rbac.interface';

export class PermissionScope {
  permission_id = 0;
  permission_name: string | null = null;
  is_scopeable = false;
  scope: string | null = null;
  created_at: string | null = null;
  updated_at: string | null = null;

  constructor(data: Partial<PermissionScopeResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.permission_name || String(this.permission_id);
  }

  get scopeLabel(): string {
    return this.scope || VALUE_UNRESOLVED;
  }
}
